export default __webpack_public_path__ + "static/QA-consulta-especialista--f0c53884d3d84bfc9d5cc9c95747ad5e.png";